import React, { FunctionComponent } from "react"; // importing FunctionComponent
import { bemModifier } from "../../../helpers/bemModifier";

type BadgeProps = {
  badgeBorderLess?: boolean;
}

export const Badge: FunctionComponent<BadgeProps> = ({ children, badgeBorderLess, ...modifiers }) => {
  if (children) {
    return <span className={`${bemModifier(modifiers, "badge")} ${badgeBorderLess ? 'badge-borderless' : ''}`}>{children}</span>;
  } else {
    return null;
  }
};
